import CmsImageForAssetRef from "src/components/images/CmsImageForAssetRef";
import { getOrgSize } from "src/components/images/imageFunctions";
import theme from "src/components/themes/DefaultTheme";
import { urlForAsset } from "src/lib/client/imageUrls";
import styled, { css } from 'src/lib/styles/css';
import IPremiumLandingPage from "src/lib/types/IPremiumLandingPage";
import { useMemo } from "react";

//#region [Props]
type LogoProps = {
	landingpage: IPremiumLandingPage;
};
//#endregion

//#region [Component]
export default function Logo({ landingpage }: LogoProps) {
	const hasTrailer = (landingpage.movie.trailers?.length ?? 0) > 0
	const [desktopUrl, orgWidth] = useMemo(() => {
		if (landingpage.logoDesktop) {
			const size = getOrgSize(landingpage.logoDesktop.logoImage.asset!._ref);
			const w = Math.min(size.width, landingpage.logoDesktop.logoWidth);
			const h = w / size.aspect;
			return [
				urlForAsset(landingpage.logoDesktop.logoImage.asset!._ref)
					.auto("format")
					.width(w).height(h)
					.url(),
				size.width
			];
		}
		return [null, undefined];
	}, [landingpage.logoDesktop])

	return <SLogoContainer $hasTrailer={hasTrailer}>
		<SLogo aria-label={landingpage.movie.title}
			$mobileWidth={landingpage.logoMobile?.logoWidth}
			$desktopWidth={landingpage.logoDesktop?.logoWidth}
			$width={orgWidth}>
			{landingpage.logoMobile && <picture>
				{desktopUrl && <source srcSet={desktopUrl} media="(min-width: 550px)" />}
				<CmsImageForAssetRef assetRef={landingpage.logoMobile.logoImage.asset!._ref!} alt={landingpage.movie.title} unoptimized width={landingpage.logoMobile.logoWidth} />
			</picture>}
		</SLogo>
	</SLogoContainer>;
}
//#endregion

//#region [Styles]
type SLogoContainerProps = {
	$hasTrailer: boolean;
}
const SLogoContainer = styled.div<SLogoContainerProps>`
	position: relative;
	width: 100%;
	min-height: 104.06417112299465240641711229947vw;
	scroll-snap-align: start;
	scroll-margin: 55px;

	@media (min-width: 550px) {
		min-height: 46.249070631970260223048327137546vw;
	}

	${props => props.$hasTrailer ? css`
		cursor: pointer;
	`: ""}
`;

type SLogoProps = {
	$mobileWidth?: number;
	$desktopWidth?: number;
	$width?: number;
};

const SLogo = styled.h1<SLogoProps>`
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: ${props => props.$width ? css`
		min(${props.$width}px, 95%)
	`: "95%"};
	color: var(--ADFREE-TITLECOLOR, #ffffff);
	text-align: center;
	font-size: 3rem;

	${props => props.$mobileWidth ? css`
		max-width: ${props.$mobileWidth}px !important;
	`: ""}

	@media (min-width: 550px) {
        /*Merk! Denne MQ var lagt inn feil mange steder i gammelt malverk (manglet paranteser) slik at den ikke slo inn*/
        ${props => props.$desktopWidth ? css`
			max-width: ${props.$desktopWidth}px !important;
	`: "max-width: 50vw;"}
	}
`;
//#endregion